import { connect } from 'react-redux'
import Lesson from './lesson'
import { withRouter } from 'react-router'
import { createSelector } from 'reselect'

const onBuilder = createSelector(
  [location => location],
  location => !location.pathname.split('/')[3]
)

const mapStateToProps = (state, { location }) => {
  return {
    onBuilder: onBuilder(location)
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Lesson)
)
